import { useEffect, useRef } from 'react';

interface SpacePanActions {
  onActivate: () => void;
  onDeactivate: () => void;
}

export function useSpacePanShortcut({ onActivate, onDeactivate }: SpacePanActions) {
  const actionsRef = useRef({ onActivate, onDeactivate });
  actionsRef.current = { onActivate, onDeactivate };

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== ' ') return;
      if (e.repeat) return;
      const target = e.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return;
      e.preventDefault();
      actionsRef.current.onActivate();
    };

    const onKeyUp = (e: KeyboardEvent) => {
      if (e.key !== ' ') return;
      actionsRef.current.onDeactivate();
    };

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
    };
  }, []);
}
